import {Injectable} from '@angular/core';
import {ErrorUtils} from '@lifeislife/lifeislife-domain';
import {BehaviorSubject, Observable, Subscription, timer} from 'rxjs';
import {Message} from 'primeng/api/message';
import {CustomerFrontErrorHandler} from '../error.handler';

export type SubscribedToExpirationMessage = Message & {
  expireSubscription: Subscription
};

@Injectable({
  providedIn: 'root',
})
export class ShellMessageService {

  messages$ = new BehaviorSubject<SubscribedToExpirationMessage[]>([]);

  constructor(
    private errorHandler: CustomerFrontErrorHandler,
  ) {
  }

  getMessages$(): Observable<Message[]> {
    return this.messages$;
  }

  clearMessage(m: Message | SubscribedToExpirationMessage) {
    if (m['expireSubscription']) {
      const subcription: Subscription = m['expireSubscription'];
      if (subcription) {
        subcription.unsubscribe();
        m['expireSubscription'] = null;
      }
    }
    const curMessages = this.messages$.getValue();
    const newMessages = curMessages.filter(curM => curM !== m);
    this.messages$.next(newMessages);
  }

  addInfo(summary: string, details?: string) {
    const newMessage = {
      key: Math.random() + '',
      severity: 'info',
      closable: true,
      summary: summary,
      detail: details,
      life: details ? 5000 : 2000,
    };
    this.enqueueMessage(newMessage);
  }


  addError(summary: string, error?: Error) {
    let errorDetails;
    const backendError = ErrorUtils.getHttpBackendError(error);
    if (backendError && backendError.message) {
      errorDetails = backendError.message;
    }
    const newMessage = {
      key: Math.random() + '',
      severity: 'error',
      closable: true,
      summary: summary,
      detail: errorDetails,
      life: 10000,
    };
    this.enqueueMessage(newMessage);
    if (error) {
      this.errorHandler.handleError(error);
    }
  }

  private enqueueMessage(newMessage: Message | Partial<Message> | SubscribedToExpirationMessage) {
    const curMessages = this.messages$.getValue();

    const subscribedMessage: SubscribedToExpirationMessage = newMessage as SubscribedToExpirationMessage;
    let subcsriptoin: Subscription = subscribedMessage.expireSubscription || null;
    if (newMessage.life && subcsriptoin == null) {
      subcsriptoin = timer(newMessage.life)
        .subscribe(() => this.clearMessage(newMessage));
      subscribedMessage.expireSubscription = subcsriptoin;
    }

    this.messages$.next([...curMessages, subscribedMessage]);
  }
}
